import { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faX,
  faBell,
} from "@fortawesome/free-solid-svg-icons";

import ThemeSwitcher from "../core/ThemeSwitcher";
import ProfileMenu from "./ProfileMenu";
import Avatar from "../core/Avatar";
import Breadcrumbs from "./Breadcrumbs";

import { useAuthInfo } from "../../context/AuthContext";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { useAppData } from "../../context/AppDataContext";

const Header = (props) => {
  const { searchTerm, setSearchTerm, history } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const { userInfo } = useAuthInfo();
  const avatarClickedRef = useRef(false);
  const { notificationCount } = useAppData();

  const getSearchResults = (e) => {
    e.preventDefault();
    history.push(`/universal-search/${searchTerm}`);
  };

  const toggleMenu = (e) => {
    avatarClickedRef.current = true;
    setMenuOpen((prev) => !prev);
  };

  return (
    <div className="navbar-container">
      <div className="nav-wrapper">
        <form onSubmit={getSearchResults}>
          <div className="search-bar-wrapper">
            <input
              type="text"
              name="search"
              placeholder="Search anything..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {!searchTerm ? (
              <FontAwesomeIcon icon={faMagnifyingGlass} color="#ffffff" />
            ) : (
              <FontAwesomeIcon
                icon={faX}
                color="#ffffff"
                className="icon-x"
                onClick={() => setSearchTerm("")}
              />
            )}
          </div>
        </form>
        <div className="bell-icon-wrapper">
          <NavLink to="/notifications/new">
            <div>
              <FontAwesomeIcon
                icon={faBell}
                className="notification-bell-icon"
              />
              {notificationCount > 0 && (
                <span className="notification-badge">{notificationCount}</span>
              )}
            </div>
          </NavLink>
        </div>
        <ThemeSwitcher />
        <Avatar userData={userInfo} onClick={toggleMenu} />
      </div>
      <div className="avatar-wrapper">
        {menuOpen && (
          <ProfileMenu
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            avatarClickedRef={avatarClickedRef}
          />
        )}
      </div>
      <Breadcrumbs />
    </div>
  );
};

export default Header;
